<template>
  <div class="bp-options-menu">
    <bp-options-menu-popper trigger="clickToToggle" :options="popperOptions">
      <div slot="reference" ref="dropdownButton">
        <bp-button
          size="md"
          color="neutral"
          variant="filled-1"
          icon="fa fa-ellipsis-vertical"
        />
      </div>

      <div slot="default" class="bp-options-menu-dropdown">
        <button
          v-for="(option, i) in options"
          class="bp-options-menu-cell btn btn-sm justify-content-start py-2 px-4 p-lg-3 text-neutral-600"
          :key="i"
          :class="option.class"
          @click="selectOption(option)"
        >
          <bp-icon class="mr-4" :size="18" :icon="option.icon" />
          <span>{{ option.label }}</span>
        </button>
      </div>
    </bp-options-menu-popper>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  components: { "bp-options-menu-popper": Popper },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    popperOptions() {
      return {
        placement: "left",
        modifiers: {
          offset: {
            offset: "4px,0"
          }
        }
      };
    }
  },
  methods: {
    selectOption(option) {
      this.$refs.dropdownButton.click();
      this.$emit("click", option, this.item);
      if (option.click) option.click(this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";
.bp-options-menu {
  .bp-options-menu-dropdown {
    padding: 8px;
    z-index: 100;
    overflow: hidden;
    border-radius: 4px;
    border: 1px solid rgba(215, 215, 215, 0.48);
    background: rgba(255, 255, 255, 0.64);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(12px);

    display: flex;
    flex-direction: column;

    .bp-options-menu-cell {
      border-radius: 4px;
      display: flex;
      &:hover {
        background-color: $neutral-048;
      }
      &:active {
        background-color: $neutral-076;
      }
    }
  }
}
</style>
